@if (!resultStatus) {
  <h1 mat-dialog-title>{{data.title}}</h1>
}
<div mat-dialog-title class="fx-row fx-justify-start fx-items-center">
  @if (resultStatus === "success") {
    <mat-icon color='accent'>check_circle_outline</mat-icon>
    <span class='h2 ml-4 primary-fg'>{{data?.title || 'Successo'}}</span>
  }
  @if (resultStatus === "error") {
    <mat-icon color='warn'>error_outline</mat-icon>
    <span class='h2 ml-4 warn-fg'>{{data?.title || 'Errore'}}</span>
  }
</div>
<mat-dialog-content class="mat-spinner-action-dialog">
  @if (loading) {
    <div class="spinner fx-row fx-justify-center fx-items-center">
      <mat-spinner></mat-spinner>
    </div>
  }
  <!--<div class="mb-4 fx-row fx-justify-start fx-items-center">
  <ng-container *ngIf='resultStatus === "success"'>
    <mat-icon color='accent'>check_circle_outline</mat-icon>
    <span class='h5'>Successo</span>
  </ng-container>
  <ng-container *ngIf='resultStatus === "error"'>
    <mat-icon  color='warn'>error_outline</mat-icon>
    <span class='h5'>Errore</span>
  </ng-container>
</div>-->
<div
  [class.warn-fg]='resultStatus === "error"'
  [class.primary-fg]='resultStatus === "success"'
  [innerHTML]="data.contentMessage"
></div>
</mat-dialog-content>
@if (!loading) {
  <mat-dialog-actions align='end'>
    @if (data.negativeText) {
      <button mat-button (click)="onNoClick()">{{data.negativeText | translate}}</button>
    }
    <button mat-flat-button (click)='onYesClick()' color='accent' >{{data.positiveText?data.positiveText:'OK' | translate}}</button>
  </mat-dialog-actions>
}
